//Enum with changes allowed in the rule.
export enum ConditionalFormattingModificationType {
    ColorText,
    FontFamily,
    ColorTextAndBackground,
    EventColor
}
